export default "__VITE_ASSET__DNLRzrcf__"